export default __webpack_public_path__ + "static/media/contact-img.07f0b3f3.png";